import * as actionTypes from './actionTypes';

export const toggleAddPaymentModal=()=>({
    type:actionTypes.TOGGLE_ADD_PAYMENT_MODAL
})